import React, { FunctionComponent, useEffect } from 'react';
import { RichText, Link, Image } from '@sitecore-jss/sitecore-jss-react';
import RoutableSitecoreLink from '../../../../react-only-components/RoutableSitecoreLink';
import { SpecialOffersSlideModel } from '../../models/cardCarousel.model';
import useMediaQuery from '../../../../lib/custom-hooks/useMediaQuery';
import { BreakpointsInPx } from '../../../.././constants/breakpoints.constants';
import { StringField } from '../../../../types/types';
import './styles.scss'

const CarouselSlide: FunctionComponent<{
  model: SpecialOffersSlideModel;
  isEE: boolean;
}> = ({ model, isEE }) => {
  const isDesktop = useMediaQuery(`(min-width: ${BreakpointsInPx['md']})`);

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  return (
    <>
      {model?.badgeLink?.value?.href && model?.badgeLink?.value?.text && (
        <div className="card-label card-label--clickable special-offers-card__label">
          <RoutableSitecoreLink field={model?.badgeLink} />
        </div>
      )}
      <div className={`special-offers-card special-offers-card--${model?.isWideCard ? 'large' : 'small'}`}>
        <div className="special-offers-card-wrapper slide-card slide-card--regular special-offer-homepage-card special-offers-card-wrapper">
          {isDesktop ?
            <Image
              loading="lazy"
              field={(model.image && (model.image?.value?.src?.length ?? 0) > 0) ? model.image : model.mobileImage}
              className={'slide-card__image special-offer-homepage-card__image'}
            /> :
            <Image
              loading="lazy"
              field={(model.mobileImage && (model.mobileImage?.value?.src?.length ?? 0) > 0) ? model.mobileImage : model.image}
              className={'slide-card__image special-offer-homepage-card__image'}
            />
          }
          <div className={'special-offer-homepage-body'}>
            <div className="special-offers-card__text-wrapper">
              <RichText tag={'h3'} field={model?.title as StringField} className="special-offer-homepage-body__title" />
              <RichText
                tag="div"
                field={model?.subtitle as StringField}
                className="special-offer-homepage-body__subtitle"
              />
            </div>
            <div className={'special-offer-homepage-body__cta-container'}>
              {(isEE || (model?.buttonPrimary?.value?.text && model?.buttonPrimary?.value?.href)) && (
                <div className="cta cta-primary-red special-offer-homepage-body__primary-cta">
                  <Link field={model?.buttonPrimary ?? {}} />
                </div>
              )}
              {((model?.type?.value !== 'offerCardWide' && !(model?.buttonPrimary?.value?.text && model?.buttonPrimary?.value?.href)) ||
                model?.type?.value === 'offerCardWide') &&
                (isEE || (model?.buttonSecondary?.value?.text && model?.buttonSecondary?.value?.href)) && (
                  <div className={'cta cta-primary-offwhitered special-offer-homepage-body__secondary-cta'}>
                    <Link field={model?.buttonSecondary ?? {}} className='special-offer-homepage-body__secondary-cta-link' />
                    <span className="link-with-arrow link-with-arrow--text">
                      <pfe-icon icon="cnh-arrow-forward" size={'24'} color={'complement'} />
                    </span>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CarouselSlide;
